import memoize from 'lodash.memoize';
import { sanitiseLocale } from './sanitiseLocale';

const isWholeNumber = (price) => price % 1 === 0;

const formatPrice = (price, currency, locale) => {
    const decimalPlaces = isWholeNumber(price) ? 0 : 2;

    const sanitisedLocale = sanitiseLocale(locale);

    const currencyFormat = Intl.NumberFormat(sanitisedLocale, {
        currency,
        style: 'currency',
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
    });

    return currencyFormat.format(price);
};

const resolve = (price, currency, locale) => `${price}/${currency}/${locale}`;

export default memoize(formatPrice, resolve);
